export default {"src":"/_next/static/media/Frame 2147227877 (1).90ed6e17.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};